export default "__VITE_ASSET__Db0MrXDt__"